import Box from "ds/components/Box";

import DashboardViewHeader from "./ViewHeader";
import DashboardContextProvider from "./Provider";
import DashboardList from "./List";
import styles from "./styles.module.css";

const Dashboard = () => {
  return (
    <DashboardContextProvider>
      <Box className={styles.wrapper} direction="column" fullWidth>
        <DashboardViewHeader />
        <DashboardList />
      </Box>
    </DashboardContextProvider>
  );
};

export default Dashboard;
